var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeaviateApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4433 31.0505C12.065 31.5246 11.3375 30.5238 11.1461 29.9641V26.0133L7.4131 28.4825C6.9289 28.7459 5.60916 29.0357 4.20379 28.0875L9.32746 31.5444C10.7058 32.4926 12.6457 31.6102 13.4433 31.0505Z",
    fill: "#61AB01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.544V24.9268C1 25.48 1.38287 26.2108 1.86146 26.5071L4.20379 28.0875C5.60916 29.0357 6.9289 28.7459 7.4131 28.4825L11.1461 26.0133V19.7908L3.39295 24.5317C2.6272 24.9268 1.76574 25.0256 1 23.544Z",
    fill: "#7DB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.7658V23.544C1.76574 25.0256 2.6272 24.9268 3.39295 24.5317L11.1461 19.7908V9.41992C11.0695 7.60255 9.23174 7.93837 8.75315 8.23468L2.43577 11.9879C1.86146 12.2842 1 12.9756 1 13.7658Z",
    fill: "url(#paint0_linear_58_116)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5567 31.0876C27.935 31.5617 28.6625 30.5609 28.8539 30.0012V26.0504L32.5869 28.5197C33.0711 28.783 34.3908 29.0728 35.7962 28.1246L30.6725 31.5815C29.2942 32.5297 27.3543 31.6473 26.5567 31.0876Z",
    fill: "#61AB01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23.5811V24.9639C39 25.5171 38.6171 26.2479 38.1385 26.5442L35.7962 28.1246C34.3908 29.0728 33.0711 28.783 32.5869 28.5197L28.8539 26.0504V19.8279L36.6071 24.5689C37.3728 24.9639 38.2343 25.0627 39 23.5811Z",
    fill: "#7DB800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13.8029V23.5811C38.2343 25.0627 37.3728 24.9639 36.6071 24.5689L28.8539 19.8279V9.45703C28.9305 7.63966 30.7683 7.97548 31.2469 8.27179L37.5642 12.025C38.1385 12.3213 39 13.0127 39 13.8029Z",
    fill: "url(#paint1_linear_58_116)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0503 30.133C11.1482 31.0326 12.3556 32.255 13.9218 30.6557C15.3249 29.3896 18.2942 26.9344 19.4689 26.9344H20.5457C21.4267 26.9344 23.9155 29.2865 26.6523 31.1496C27.2397 31.5494 29.1601 31.7323 29.039 28.3338V26.2347L22.3078 21.7366C20.4282 20.6171 18.7184 21.2035 18.0984 21.6366L11.0503 26.0348V30.133Z",
    fill: "url(#paint2_linear_58_116)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9795 15.939C16.3364 16.139 13.0081 18.538 11.0503 19.8374V26.0348L18.0984 21.6366C18.7184 21.2035 20.4282 20.6171 22.3078 21.7366L29.039 26.2347L28.8538 19.8374C23.6852 16.159 22.2099 16.039 21.3288 15.939L18.9795 15.939Z",
    fill: "url(#paint3_linear_58_116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_116",
    x1: 7.22166,
    y1: 8,
    x2: 7.22166,
    y2: 31.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#A5CA01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_116",
    x1: 32.7783,
    y1: 8.03711,
    x2: 32.7783,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#A5CA01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_116",
    x1: 20.0563,
    y1: 21.2368,
    x2: 20.0474,
    y2: 31.3471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06C253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4C8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_116",
    x1: 20.0559,
    y1: 20.9647,
    x2: 20.1591,
    y2: 15.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06C57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87DC14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeaviateApp);
export default __webpack_public_path__ + "static/media/weaviate-app.6adeb33ad7f07f39d8635b296c0a1768.svg";
export { ForwardRef as ReactComponent };